<template>
  <div v-if="isTowerCo() && this.value && this.value > 0">
    <el-tooltip :content="title" placement="top" effect="dark">
      <el-badge v-if="isDesktop" :value="value" :type="badgeColor()">
        <i :class="'fa fa-' + this.icon"></i>
      </el-badge>
      <div v-else>
        <i :class="'fa fa-' + this.icon"></i>&nbsp;<span class="badge">{{value}}</span>
      </div>
    </el-tooltip>
  </div>
  <div v-else>
    <el-tooltip :content="title" placement="top" effect="dark">
      <i :class="'fa fa-' + this.icon"></i>
    </el-tooltip>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true
    },

    prop: {
      type: String,
      default: null
    },

    data: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  methods: {
    badgeColor () {
      if (this.prop) {
        let v1 = this.data[this.prop]
        let v2 = this.baseline[this.prop]

        if (v1 === v2) {
          return 'primary'
        } else {
          return 'warning'
        }
      } else {
        return 'info'
      }
    }
  },

  data () {
    return {
      value: this.prop ? this.data[this.prop] : null,
      baseline: this.clone(this.data)
    }
  }
}
</script>

<style scoped>
.badge {
  background-color: #409EFF;
  font-size: 0.741rem;
  color: white;
  padding: 4px 8px;
  text-align: center;
  border-radius: 2.58px;
}
</style>



// WEBPACK FOOTER //
// SitesMenuBadge.vue?77018d5c